import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/gebrauchtwagen-kaufen-in-deutschland-von-gepruften/")({
  head: () => routeHead("/de/gebrauchtwagen-kaufen-in-deutschland-von-gepruften/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/cars", statusCode: 301, replace: true });
  },
});
